export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5647.5348a30b.jpg";